// const MainAddress = "https://192.168.1.140:5000/";
const MainAddress ="https://www.sabaapi.com/webapi/managerVisitor/";
export default MainAddress;